"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  shell: {
    componentTitle: "Configurations d'exécution",
    incompletePropsMessage: 'Les informations fournies ne sont pas suffisantes, veuillez remplir tous les champs de commande de test requis.'
  },
  selectedConfigurationDisplay: {
    selectedConfigurationLabel: 'CONFIGURATION SÉLECTIONNÉE:',
    noSelectedConfigurationLabel: 'Sélectionnez une configuration:',
    clearButton: 'Effacer la sélection'
  },
  fulfillmentConfigurationList: {
    actions: {
      error500: "Une erreur s'est produite lors de la récupération de la liste des configurations d'exécution." + ' Vous pouvez appuyer sur Réessayer pour voir si le problème est résolu.',
      permissionsError: "Il semble que vous ne disposez pas des autorisations nécessaires pour afficher ces configurations d'exécution." + " Veuillez contacter l'assistance de la plate-forme pour obtenir l'accès.",
      unknownError: 'Une erreur inconnue est survenue. Veuillez réessayer.'
    },
    table: {
      nameHeader: "Nom de la configuration d'exécution"
    },
    selectVersionButton: 'Sélectionnez la version'
  },
  fulfillmentConfigurationErrorPage: {
    noAvailableFulfillmentConfigurations: {
      titleText: "Il n'y a pas de configurations d'exécution disponibles pour ce produit.",
      productAssociationsSuggestion: 'Vérifier votre ',
      productAssociationsLink: 'Associations de produits',
      fulfillmentConfigurationsSuggestion: 'Create a new ',
      fulfillmentConfigurationsLink: "Configuration d'exécution",
      emailSuggestion: "Besoin de plus d'assistance? Contacter ",
      emailLink: 'platformsupport@cimpress.com',
      tryAgainText: 'Avez-vous fait quelques changements? Cliquez ici pour essayer à nouveau.'
    },
    error: {
      errorTitle: "Une erreur s'est produite lors du chargement des configurations d'exécution"
    },
    reloadButtonText: 'Recharger'
  },
  search: {
    searchFieldLabel: 'Rechercher des configurations'
  },
  versionsList: {
    table: {
      moreInfoButton: "Plus d'informations",
      rowContentsHeader: 'Version',
      noVersionsText: 'Aucune version trouvée'
    },
    backButton: 'Retour'
  }
};
exports["default"] = _default;